/** French candidate strings — assessment. Key = the exact English text passed to t(), value = French. */
const fr = {
  // ── Shared page chrome (join / results) ──
  'Powered by': 'Propulsé par',
  'Your screening journey': 'Votre parcours de présélection',
  'Step {number}': 'Étape {number}',
  // Step labels (passed dynamically)
  'Basic details': 'Informations de base',
  'Resume upload': 'Envoi du CV',
  'Document upload': 'Envoi de documents',
  'Application form': 'Formulaire de candidature',
  Assessment: 'Évaluation',
  'AI interview': 'Entretien IA',
  'AI video interview': 'Entretien vidéo IA',
  'AI voice interview': 'Entretien vocal IA',
  "Time's up": 'Temps écoulé',
  'Leave this page?': 'Quitter cette page ?',
  'Refreshing or closing this page may auto-submit your assessment and affect your progress. Please stay on this page until you complete this step or your time runs out.':
    'Actualiser ou fermer cette page peut soumettre automatiquement votre évaluation et affecter votre progression. Veuillez rester sur cette page jusqu’à la fin de cette étape ou de votre temps imparti.',

  // ── AssessmentJoin ──
  'Your session expired. Please confirm your details to restart.':
    'Votre session a expiré. Veuillez confirmer vos informations pour recommencer.',
  'Welcome back — you can continue from this step.': 'Bon retour — vous pouvez reprendre à partir de cette étape.',
  'Loading assessment...': 'Chargement de l’évaluation...',
  'Assessment Not Available': 'Évaluation non disponible',
  'Go Back': 'Retour',
  'Assessment Not Found': 'Évaluation introuvable',
  "The assessment you're looking for doesn't exist or is no longer available.":
    'L’évaluation que vous recherchez n’existe pas ou n’est plus disponible.',
  'Verifying your information…': 'Vérification de vos informations…',
  'Before you begin': 'Avant de commencer',
  'Read each question carefully and answer confidently.': 'Lisez attentivement chaque question et répondez avec assurance.',
  'This session is monitored. No external help, tab switching, or extra devices.':
    'Cette session est surveillée. Aucune aide extérieure, aucun changement d’onglet ni appareil supplémentaire.',
  "Give it your best. We're rooting for you!": 'Donnez le meilleur de vous-même. Nous vous souhaitons bonne chance !',
  Type: 'Type',
  Duration: 'Durée',
  '{minutes} min': '{minutes} min',
  Questions: 'Questions',
  Points: 'Points',
  Instructions: 'Instructions',
  'Enter your information': 'Saisissez vos informations',
  'We need your name and email to verify your invite.':
    'Nous avons besoin de votre nom et de votre adresse e-mail pour vérifier votre invitation.',
  'Full name': 'Nom complet',
  'Your full name': 'Votre nom complet',
  'Prefilled from the link and cannot be changed.': 'Prérempli à partir du lien et non modifiable.',
  Email: 'E-mail',
  'Verifying…': 'Vérification…',
  'Continue to Assessment': 'Continuer vers l’évaluation',
  'Start your assessment': 'Commencez votre évaluation',
  'Time up – window closed': 'Temps écoulé – délai expiré',
  'Start within {time}': 'Temps restant pour commencer : {time}',
  'You need to start the assessment within 10 minutes of opening this page. After that, your screening window may automatically close based on your deadline.':
    'Vous devez commencer l’évaluation dans les 10 minutes suivant l’ouverture de cette page. Passé ce délai, votre période de présélection peut se fermer automatiquement en fonction de votre date limite.',
  'Takes about {minutes} mins': 'Environ {minutes} min',
  'Complete the assessment in one sitting.': 'Effectuez l’évaluation en une seule fois.',
  'Be focused and confident': 'Gardez votre concentration et votre confiance',
  'Read each question carefully.': 'Lisez attentivement chaque question.',
  'Quiet spot & strong Wi‑Fi': 'Endroit calme et bon Wi‑Fi',
  'Minimize distractions around you.': 'Limitez les distractions autour de vous.',
  'Reviewed by a human': 'Examiné par une personne',
  'A recruiter will review your responses.': 'Un recruteur examinera vos réponses.',
  'Assessment Modules': 'Modules de l’évaluation',
  'This assessment is broken down into {count} parts. You will take them one by one.':
    'Cette évaluation est divisée en {count} parties. Vous les passerez l’une après l’autre.',
  'Module {number}': 'Module {number}',
  '{minutes} mins': '{minutes} min',
  'Camera & Audio:': 'Caméra et audio :',
  'You will be recorded via webcam and microphone': 'Votre session sera enregistrée par la webcam et le microphone',
  'Attire:': 'Tenue :',
  'Please dress appropriately (formal or professional attire)':
    'Veuillez porter une tenue appropriée (tenue formelle ou professionnelle)',
  'Environment:': 'Environnement :',
  'Ensure a quiet, well-lit space with stable internet':
    'Installez-vous dans un endroit calme et bien éclairé, avec une connexion Internet stable',
  'Important:': 'Important :',
  'Microphone access granted': 'Accès au microphone autorisé',
  'Microphone access denied': 'Accès au microphone refusé',
  'Microphone access required': 'Accès au microphone requis',
  'Your microphone is ready. You can now start the assessment.':
    'Votre microphone est prêt. Vous pouvez maintenant commencer l’évaluation.',
  'Please allow microphone access in your browser settings and refresh the page. This assessment includes a passage reading section that requires audio recording.':
    'Veuillez autoriser l’accès au microphone dans les paramètres de votre navigateur, puis actualiser la page. Cette évaluation comprend une section de lecture de texte qui nécessite un enregistrement audio.',
  'This assessment includes a passage reading section. You will need to read a passage aloud, and your audio will be recorded.':
    'Cette évaluation comprend une section de lecture de texte. Vous devrez lire un texte à voix haute, et votre voix sera enregistrée.',
  'Requesting...': 'Demande en cours...',
  'Allow Microphone': 'Autoriser le microphone',
  'Webcam access granted': 'Accès à la webcam autorisé',
  'Webcam access denied': 'Accès à la webcam refusé',
  'Webcam access required': 'Accès à la webcam requis',
  'Your webcam is ready. The proctoring session will be active during the assessment.':
    'Votre webcam est prête. La surveillance sera active pendant l’évaluation.',
  'Please allow webcam access in your browser settings and refresh the page. This assessment has video proctoring enabled.':
    'Veuillez autoriser l’accès à la webcam dans les paramètres de votre navigateur, puis actualiser la page. La surveillance vidéo est activée pour cette évaluation.',
  'This assessment has video proctoring enabled. You must grant webcam access to proceed.':
    'La surveillance vidéo est activée pour cette évaluation. Vous devez autoriser l’accès à la webcam pour continuer.',
  'Allow Webcam': 'Autoriser la webcam',
  'Enable Microphone to Start': 'Activez le microphone pour commencer',
  'Enable Webcam to Start': 'Activez la webcam pour commencer',
  'Start Assessment': 'Commencer l’évaluation',
  // Join errors (set in code, shown later)
  'Assessment not found or no longer available': 'Évaluation introuvable ou plus disponible',
  'Failed to load assessment. Please check the link and try again.':
    'Impossible de charger l’évaluation. Veuillez vérifier le lien et réessayer.',
  'Please enter a valid email address': 'Veuillez saisir une adresse e-mail valide',
  'You have already completed this assessment. You cannot take it again.':
    'Vous avez déjà effectué cette évaluation. Vous ne pouvez pas la repasser.',
  'Failed to start assessment. Please try again.': 'Impossible de démarrer l’évaluation. Veuillez réessayer.',
  'Your screening window has ended. You can no longer start this assessment.':
    'Votre période de présélection est terminée. Vous ne pouvez plus commencer cette évaluation.',
  'Please provide both name and email': 'Veuillez indiquer votre nom et votre adresse e-mail',

  // ── AssessmentTake ──
  'You have already completed this assessment. Multiple submissions are not allowed.':
    'Vous avez déjà effectué cette évaluation. Les soumissions multiples ne sont pas autorisées.',
  'Failed to submit assessment: {error}': 'Échec de la soumission de l’évaluation : {error}',
  'Unknown error occurred': 'Une erreur inconnue s’est produite',
  'Could not access microphone. Please check your browser permissions.':
    'Impossible d’accéder au microphone. Veuillez vérifier les autorisations de votre navigateur.',
  'You are not invited to this assessment.': 'Vous ne figurez pas parmi les personnes invitées à cette évaluation.',
  'Failed to load assessment.': 'Impossible de charger l’évaluation.',
  'Loading your assessment…': 'Chargement de votre évaluation…',
  'Assessment not available': 'Évaluation non disponible',
  'Back to screening': 'Retour à la présélection',
  'Open the assessment from your screening link or invitation.':
    'Ouvrez l’évaluation à partir de votre lien de présélection ou de votre invitation.',
  'Please use the link from your screening or invitation. If you refreshed, use the same browser tab link that includes your email, or go back to the screening hub.':
    'Veuillez utiliser le lien de votre présélection ou de votre invitation. Si vous avez actualisé la page, utilisez le lien du même onglet qui contient votre adresse e-mail, ou revenez à l’espace de présélection.',
  '{answered} of {total} answered': '{answered} sur {total} répondues',
  '{current} of {total}': '{current} sur {total}',
  Sealed: 'Validée',
  'Draft saved': 'Brouillon enregistré',
  'Not saved': 'Non enregistrée',
  'Time Left': 'Temps restant',
  // Module transition
  '{title} — Complete': '{title} — Terminé',
  'Module Complete': 'Module terminé',
  'Your answers for this module have been saved successfully. You cannot return to previous modules.':
    'Vos réponses pour ce module ont bien été enregistrées. Vous ne pouvez pas revenir aux modules précédents.',
  'Next Module': 'Module suivant',
  'Assessment Test': 'Test d’évaluation',
  'Pronunciation Assessment': 'Évaluation de la prononciation',
  'Reading Comprehension': 'Compréhension écrite',
  'Answer a series of questions designed to assess your knowledge, reasoning, and decision-making skills.':
    'Répondez à une série de questions conçues pour évaluer vos connaissances, votre raisonnement et votre capacité de prise de décision.',
  'The next section requires you to read the displayed words or passage aloud using your microphone. Speak clearly and naturally.':
    'La section suivante vous demande de lire à voix haute les mots ou le texte affichés à l’aide de votre microphone. Parlez clairement et naturellement.',
  'The next section requires you to read a passage and answer questions based on the information provided.':
    'La section suivante vous demande de lire un texte et de répondre à des questions à partir des informations fournies.',
  'The next section contains a series of questions. Read each question carefully and select or provide the most appropriate answer.':
    'La section suivante contient une série de questions. Lisez attentivement chaque question et choisissez ou indiquez la réponse la plus appropriée.',
  '{minutes} minutes': '{minutes} minutes',
  '{count} question': '{count} question',
  '{count} questions': '{count} questions',
  'Module {current} of {total} • Starting automatically in {seconds}s':
    'Module {current} sur {total} • Démarrage automatique dans {seconds} s',
  'Start Module Now': 'Commencer le module maintenant',
  'Finish questionnaire': 'Terminer le questionnaire',
  Submit: 'Soumettre',
  // Question view
  'Question {number}': 'Question {number}',
  '{count} point': '{count} point',
  '{count} points': '{count} points',
  'From: {source}': 'Source : {source}',
  'Read the following paragraph:': 'Lisez le paragraphe suivant :',
  'Select all correct answers:': 'Sélectionnez toutes les bonnes réponses :',
  'Select the correct answer:': 'Sélectionnez la bonne réponse :',
  'Your answer:': 'Votre réponse :',
  'Type your answer here...': 'Saisissez votre réponse ici...',
  'Write your detailed answer here...': 'Rédigez votre réponse détaillée ici...',
  'Enter your answer...': 'Saisissez votre réponse...',
  True: 'Vrai',
  False: 'Faux',
  // Passage reading
  'Read the following passage aloud:': 'Lisez le texte suivant à voix haute :',
  'No passage available.': 'Aucun texte disponible.',
  'Audio Recording': 'Enregistrement audio',
  'Recording...': 'Enregistrement...',
  'Read the passage clearly into your microphone': 'Lisez le texte clairement dans votre microphone',
  'Stop Recording': 'Arrêter l’enregistrement',
  'Click the button below to start recording. Read the passage above clearly and at a natural pace.':
    'Cliquez sur le bouton ci-dessous pour commencer l’enregistrement. Lisez le texte ci-dessus clairement et à un rythme naturel.',
  'Start Recording': 'Commencer l’enregistrement',
  'Recording saved successfully': 'Enregistrement sauvegardé avec succès',
  'Re-record': 'Réenregistrer',
  // Navigation
  Previous: 'Précédent',
  'Loading...': 'Chargement...',
  'Review Answers': 'Vérifier les réponses',
  'Save & Next': 'Enregistrer et continuer',
  'No questions available.': 'Aucune question disponible.',
  'Open question navigator': 'Ouvrir le navigateur de questions',
  'Question Navigator': 'Navigateur de questions',
  'Close question navigator': 'Fermer le navigateur de questions',
  Current: 'Question actuelle',
  Draft: 'Brouillon',
  Unanswered: 'Sans réponse',
  Skipped: 'Ignorée',
  // Time warning
  'Time Warning': 'Avertissement de temps',
  'You have 5 minutes remaining to complete your assessment. Please review your answers and submit when ready.':
    'Il vous reste 5 minutes pour terminer votre évaluation. Veuillez vérifier vos réponses et soumettre l’évaluation dès que possible.',
  'Got it': 'Compris',
  // Review / confirm
  'Confirm each question before final submit. You can still jump back and edit.':
    'Vérifiez chaque question avant la soumission finale. Vous pouvez encore revenir en arrière pour modifier vos réponses.',
  'Untitled question': 'Question sans titre',
  'Sealed means saved for submission. It does not mean correct.':
    '« Validée » signifie enregistrée pour la soumission, et non correcte.',
  'Saved (not graded)': 'Enregistrée (non notée)',
  Edit: 'Modifier',
  Back: 'Retour',
  Continue: 'Continuer',
  'Continue to Submit': 'Continuer vers la soumission',
  'Complete this module?': 'Terminer ce module ?',
  'Submit Assessment?': 'Soumettre l’évaluation ?',
  'Are you sure you want to complete this module? You won’t be able to return to it, and the next module will begin.':
    'Voulez-vous vraiment terminer ce module ? Vous ne pourrez pas y revenir, et le module suivant commencera.',
  'Are you sure you want to submit your assessment? This action cannot be undone.':
    'Voulez-vous vraiment soumettre votre évaluation ? Cette action est irréversible.',
  Cancel: 'Annuler',
  'Submitting...': 'Soumission en cours...',
  'Save & Next Module': 'Enregistrer et passer au module suivant',

  // ── AssessmentResults ──
  'No assessment data available': 'Aucune donnée d’évaluation disponible',
  'Processing your assessment...': 'Traitement de votre évaluation...',
  'Something went wrong': 'Une erreur s’est produite',
  'Please use the link from your invitation email to access the assessment.':
    'Veuillez utiliser le lien figurant dans votre e-mail d’invitation pour accéder à l’évaluation.',
  'Go back': 'Retour',
  'Assessment completed!': 'Évaluation terminée !',
  'What happens next?': 'Et maintenant ?',
  "Next, you'll complete a short AI interview to help us understand how you think and communicate.":
    'Vous allez maintenant passer un court entretien IA qui nous aidera à comprendre votre façon de réfléchir et de communiquer.',
  Evaluation: 'Évaluation',
  'Your assessment and interview will be reviewed together against the role requirements.':
    'Votre évaluation et votre entretien seront examinés ensemble au regard des exigences du poste.',
  'Get in Touch': 'Prise de contact',
  "We'll email you once a decision is made about next steps.":
    'Nous vous enverrons un e-mail dès qu’une décision aura été prise concernant les prochaines étapes.',
  'Review Process': 'Processus d’examen',
  'Our team will carefully review your assessment responses.':
    'Notre équipe examinera attentivement vos réponses à l’évaluation.',
  'Your responses will be evaluated against the role requirements.':
    'Vos réponses seront évaluées au regard des exigences du poste.',
  'Check Your Email': 'Consultez vos e-mails',
  "We'll send updates to your registered email": 'Nous vous enverrons nos nouvelles à l’adresse e-mail enregistrée',
  'Assessment Saved': 'Évaluation enregistrée',
  'Your responses have been securely recorded': 'Vos réponses ont été enregistrées en toute sécurité',
  'Response Time': 'Délai de réponse',
  'Expect to hear from us in 3-5 days': 'Vous aurez de nos nouvelles sous 3 à 5 jours',
  "When you're ready, continue to the AI interview.": 'Lorsque vous le souhaitez, passez à l’entretien IA.',
  'Take me to AI interview': 'Accéder à l’entretien IA',
  'Complete Screening': 'Terminer la présélection',
  'If you have any questions, please reach out at the email provided in your invitation, or':
    'Pour toute question, écrivez à l’adresse e-mail indiquée dans votre invitation, ou',
  'contact support': 'contactez le support',

  // ── ProctoringMonitor ──
  'Failed to initialize monitoring system': 'Impossible d’initialiser le système de surveillance',
  'Could not reach the server. Make sure the backend is running (port 5001).':
    'Impossible de joindre le serveur. Vérifiez que le serveur est en cours d’exécution (port 5001).',
  'Critical violation: {description}': 'Infraction critique : {description}',
  'High severity violation: {description}': 'Infraction grave : {description}',
  'Violation: {description}': 'Infraction : {description}',
  'Full screen mode activated': 'Mode plein écran activé',
  'Failed to enter full screen mode': 'Impossible de passer en mode plein écran',
  'Exited full screen mode': 'Mode plein écran désactivé',
  'Failed to exit full screen mode': 'Impossible de quitter le mode plein écran',
  'Proctoring Active': 'Surveillance active',
  'Full Screen': 'Plein écran',
  Exit: 'Quitter',
  Enter: 'Activer',
  'Camera Active': 'Caméra active',
  'Camera Inactive': 'Caméra inactive',
  'Multiple violations detected. Please follow test guidelines.':
    'Plusieurs infractions détectées. Veuillez respecter les consignes de l’évaluation.',

  // ── LikertQuestionnaire (chrome + answer scale; statements stay as authored) ──
  'Work Style Questionnaire': 'Questionnaire sur le style de travail',
  'Page {page} of {pages} · {answered}/{total} answered': 'Page {page} sur {pages} · {answered}/{total} répondues',
  'How accurately does each statement describe you? There are no right or wrong answers — answer as you honestly see yourself now, not as you wish to be.':
    'Dans quelle mesure chaque affirmation vous décrit-elle ? Il n’y a pas de bonnes ou de mauvaises réponses — répondez en toute honnêteté selon la façon dont vous vous voyez aujourd’hui, et non telle que vous aimeriez être.',
  'Very Inaccurate': 'Très inexact',
  'Moderately Inaccurate': 'Plutôt inexact',
  'Neither Accurate Nor Inaccurate': 'Ni exact ni inexact',
  'Moderately Accurate': 'Plutôt exact',
  'Very Accurate': 'Très exact',
  'Answer every statement on this page to continue.': 'Répondez à toutes les affirmations de cette page pour continuer.',
  Next: 'Suivant',

  // ── Server messages a candidate can see (assessment share / candidate-start / submit) ──
  'Assessment not found': 'Évaluation introuvable',
  'Assessment not found or not available': 'Évaluation introuvable ou non disponible',
  'This assessment is no longer available. The associated job posting has been deleted or cancelled.':
    'Cette évaluation n’est plus disponible. L’offre d’emploi associée a été supprimée ou annulée.',
  'Your application has already been processed and does not meet the criteria to proceed.':
    'Votre candidature a déjà été traitée et ne remplit pas les critères pour poursuivre.',
  'You have already completed this assessment. Multiple attempts are not allowed.':
    'Vous avez déjà effectué cette évaluation. Les tentatives multiples ne sont pas autorisées.',
  'You are not invited to this assessment': 'Vous ne figurez pas parmi les personnes invitées à cette évaluation',
  'Your organisation has used all available credits for this billing period.':
    'Votre organisation a utilisé tous les crédits disponibles pour cette période de facturation.',
  'Email is required': 'L’adresse e-mail est requise',
  'Missing required fields': 'Champs obligatoires manquants',
  'Assessment not found or not multi-module': 'Évaluation introuvable ou non multimodule',
  'Module test not found': 'Test du module introuvable',
  'Server error': 'Erreur du serveur',

  // ── Assessment type (Assessment.questionType enum) ──
  Eligibility: 'Éligibilité',
  Technical: 'Technique',
  Behavioral: 'Comportemental',
  Cultural: 'Culturel',
};

export default fr;
